import { IconPlus, IconX } from "@tabler/icons-react";
import { useMemo } from "react";

import ConfirmationButton from "../../../../components/shared/ConfirmationButton/ConfirmationButton";
import { useDispatch, useSelector } from "../../../../redux/hooks";
import {
  addDynamicSection,
  removeDynamicSection,
} from "../../../../redux/slices/generatorSlice";
import { Flex } from "../../../../styled";
import { getRowWithExclusives } from "../../../../utils/logbookUtils/getRowWithExclusives";
import RowActionButton from "../../../_Buttons/RowActionButton/RowActionButton";
import { useTriggerAutoSave } from "../../../hooks/useTriggerAutoSave";
import { clearRow } from "../../../utils/dynamicRows";

interface Props {
  sectionIndex: number;
  addSections?: boolean;
  cloneSections?: boolean;
}

const ControlDynamicSection = ({
  sectionIndex,
  addSections,
  cloneSections,
}: Props) => {
  const dispatch = useDispatch();
  const { sections } = useSelector(state => state.generatorSlice.lbentry);
  const triggerAutoSave = useTriggerAutoSave();
  const handleAddSection = (copy: boolean = false) => {
    const newSection = structuredClone(sections[sectionIndex]);
    newSection.rows = newSection.rows.map((_, idx) => {
      const rowWithIds: any = getRowWithExclusives(newSection, idx);
      return !copy ? clearRow(rowWithIds) : rowWithIds;
    });
    dispatch(
      addDynamicSection({
        sectionIndex: sectionIndex + 1,
        section: newSection,
      }),
    );
    triggerAutoSave();
  };
  const handleDeleteSection = () => {
    dispatch(removeDynamicSection(sectionIndex));
    triggerAutoSave();
  };

  const showAddButton = useMemo(() => {
    const dynamicSection = sections[sectionIndex].dynamicSection;
    if (!dynamicSection) return false;
    if (sectionIndex === sections.length - 1) {
      return true;
    }
    return !sections[sectionIndex + 1].dynamicSection;
  }, [sections, sectionIndex]);

  const showDeleteButton = useMemo(() => {
    if (!showAddButton) return false;
    return sectionIndex - 1 >= 0 && sections[sectionIndex - 1].dynamicSection;
  }, [showAddButton]);

  if (!showAddButton) return null;

  return (
    <Flex style={{ width: "100%" }} justify="center">
      {addSections && (
        <RowActionButton
          icon={<IconPlus size="1.5rem" />}
          onClick={() => handleAddSection()}>
          Add Section
        </RowActionButton>
      )}
      {cloneSections && (
        <RowActionButton
          icon={<IconPlus size="1.5rem" />}
          onClick={() => handleAddSection(true)}>
          Copy Section
        </RowActionButton>
      )}

      {showDeleteButton && (
        <ConfirmationButton
          modalText="Are you sure you want to delete this section?"
          onConfirm={handleDeleteSection}
          buttonProps={{
            leftIcon: <IconX size="1.5rem" />,
            color: "red",
            mt: 15,
          }}>
          Delete Section
        </ConfirmationButton>
      )}
    </Flex>
  );
};
export default ControlDynamicSection;
